<template>
  <DataList
    title="Категорії продуктів"
    resource="product-categories"
    :columns="columns"
    :get-items-fn="getProductCategories"
    :search-label="'Пошук за назвою категорії продукта'"
  />
</template>

<script>
import * as productCategoriesApi from "@/backend/productCategoriesApi.js";

export default {
  data: () => ({
    columns: [
      { title: "id", name: "id" },
      { title: "Найменування", name: "title" },
      { title: "Відсоток", name: "percent" },
    ],
  }),
  methods: {
    getProductCategories(...args) {
      return productCategoriesApi.getProductCategories(
        args[0],
        args[1],
        args[2],
        args[3]
      );
    },
  },
};
</script>
